import React, { Component } from "react";
import { Button, Container } from "reactstrap";
import AppNavbar from "./AppNavbar";
import AssessmentIcon from "@material-ui/icons/Assessment";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import { DateRangePicker } from "rsuite";
import "rsuite/dist/styles/rsuite-default.css";
import { instanceOf } from "prop-types";
import { withCookies, Cookies } from "react-cookie";
import localConfig from "./localConfig.json";
import Chart from "./components/Chart";
import CountyList from "./components/CountyList";

class ManagerDashboard extends Component {
  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  };

  constructor(props) {
    super(props);
    const { cookies } = props;
    this.state = {
      isLoading: true,
      csrfToken: cookies.get("XSRF-TOKEN"),
      pagedEvents: {},
      pages: [],
      currentPage: 0,
      currentPaginationHop: 1,
      maxPaginationHops: 1,
      pageSelectionCount: 10,
      sortedField: null,
      sortOrder: null,
      dropdownOpen: false,
      dateRange: [],
      fromDate: null,
      toDate: null,
      eventTypes: [],
      eventTypesFiltered: [],
      eventStatuses: [],
      statusFiltered: [],
      upcomingEventsCheck: true,
      allExportedEvents: "",
      allEventsExportTrigger: false,
      activePresenters: null,
      reportCalled: false,
      currentPresenterId: -1,
      currentPresenter: null,
      expanded: false,
    };
    this.createPageArray = this.createPageArray.bind(this);
    this.pageLink = this.pageLink.bind(this);
    this.pageSizeLink = this.pageSizeLink.bind(this);
    this.getSortedField = this.getSortedField.bind(this);
    this.toggle = this.toggle.bind(this);
    this.setDateRange = this.setDateRange.bind(this);
    this.filterEventTypes = this.filterEventTypes.bind(this);
    this.handleUpcomingEventsCheckbox =
      this.handleUpcomingEventsCheckbox.bind(this);
    this.getPresenterDefaultEventsView =
      this.getPresenterDefaultEventsView.bind(this);
  }

  async componentDidMount() {
    this.setState({ isLoading: true });
    // active MOCs
    fetch(
      "https://" +
        localConfig.SERVICE.URL +
        ":" +
        localConfig.SERVICE.PORT +
        "/api/activePresenters",
      {
        credentials: "include",
      }
    )
      .then((response) => response.json())
      .then((data) =>
        this.setState({
          activePresenters: data,
          isLoading: false,
        })
      );
  }

  async getPresenterDefaultEventsView(presenterId) {
console.log("getDataPresentationView()");
    const { activePresenters } = this.state;
    this.setState({
      currentPresenter: activePresenters.find(
        (option) => option.presenterId === presenterId
      ),
      currentPresenterId: presenterId,
    });
    this.handleChange("panel1a").call();
    // fetch(
    //   "https://" +
    //     localConfig.SERVICE.URL +
    //     ":" +
    //     localConfig.SERVICE.PORT +
    //     `/api/sorted-default-presenter-events/${presenterId}`,
    //   { credentials: "include" }
    // )
    //   .then((response) => response.json())
    //   .then((data) =>
    //     this.setState({
    //       pagedEvents: data,
    //       reportCalled: true,
    //       currentPresenterId: presenterId,
    //     })
    //   )
    //   .then(() => this.createPageArray());
    if (this.state.eventTypes.length === 0) {
      const fetchedEventTypes = await (
        await fetch(
          "https://" +
            localConfig.SERVICE.URL +
            ":" +
            localConfig.SERVICE.PORT +
            "/api/all-event-types",
          {
            credentials: "include",
          }
        )
      ).json();
      this.setState({
        eventTypes: fetchedEventTypes,
      });
    }
  }

  toggle() {
    this.setState((prevState) => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));
  }

  async createPageArray() {
    const { pagedEvents } = this.state;
    let { maxPaginationHops, pageSelectionCount } = this.state;
    let pages = [];
    let totalPages = pagedEvents.totalPages;
    maxPaginationHops = Math.ceil(totalPages / pageSelectionCount);

    if (totalPages <= pageSelectionCount) {
      for (let i = 0; i < totalPages; i++) {
        pages.push(i + 1);
      }
    } else {
      for (let i = 0; i < pageSelectionCount; i++) {
        pages.push(i + 1);
      }
    }
    this.setState({ pages: pages, maxPaginationHops });
  }

  async handleUpcomingEventsCheckbox() {
    await this.setState((prevState) => ({
      upcomingEventsCheck: !prevState.upcomingEventsCheck,
    }));
  }

  eventTypesQueryURL(eveTypesArray) {
    const queryURL = eveTypesArray
      .map((type) => {
        return "eveType=" + type;
      })
      .join("&");
    return queryURL;
  }

  eventStatusesQueryURL(statusArray) {
    const queryURL = statusArray
      .map((status) => {
        return "eveStatus=" + status;
      })
      .join("&");
    return queryURL;
  }

  async pageLink(page) {
    const {
      pagedEvents,
      sortedField,
      sortOrder,
      fromDate,
      toDate,
      eventTypesFiltered,
      statusFiltered,
      upcomingEventsCheck,
      currentPresenterId,
    } = this.state;
    const pageSize = pagedEvents.pageable.pageSize;

    let eveTypesQuery = this.eventTypesQueryURL(eventTypesFiltered);
    let eveStatusQuery = this.eventStatusesQueryURL(statusFiltered);

    const fetchedPage = await (
      await fetch(
        "https://" +
          localConfig.SERVICE.URL +
          ":" +
          localConfig.SERVICE.PORT +
          `/api/sorted-filtered-presenter-events/${currentPresenterId}/${page}/${pageSize}/${sortedField}/${sortOrder}/${fromDate}/${toDate}/${upcomingEventsCheck}?${eveTypesQuery}&${eveStatusQuery}`,
        {
          credentials: "include",
        }
      )
    ).json();
    this.setState({ pagedEvents: fetchedPage, currentPage: page });
  }

  async pageSizeLink(size) {
    const {
      sortedField,
      sortOrder,
      fromDate,
      toDate,
      eventTypesFiltered,
      statusFiltered,
      upcomingEventsCheck,
      currentPresenterId,
    } = this.state;

    let eveTypesQuery = this.eventTypesQueryURL(eventTypesFiltered);
    let eveStatusQuery = this.eventStatusesQueryURL(statusFiltered);

    const fetchedPage = await (
      await fetch(
        "https://" +
          localConfig.SERVICE.URL +
          ":" +
          localConfig.SERVICE.PORT +
          `/api/sorted-filtered-presenter-events/${currentPresenterId}/0/${size}/${sortedField}/${sortOrder}/${fromDate}/${toDate}/${upcomingEventsCheck}?${eveTypesQuery}&${eveStatusQuery}`,
        {
          credentials: "include",
        }
      )
    ).json();
    this.setState({
      pagedEvents: fetchedPage,
      currentPage: 0,
      currentPaginationHop: 1,
    });
    this.createPageArray();
  }

  async getSortedField(fieldName) {
    const {
      sortedField,
      pagedEvents,
      fromDate,
      toDate,
      eventTypesFiltered,
      statusFiltered,
      upcomingEventsCheck,
      currentPresenterId,
    } = this.state;
    let { sortOrder } = this.state;

    let eveTypesQuery = this.eventTypesQueryURL(eventTypesFiltered);
    let eveStatusQuery = this.eventStatusesQueryURL(statusFiltered);

    const pageSize = pagedEvents.pageable.pageSize;
    if (fieldName === sortedField) {
      if (sortOrder === "asce") {
        sortOrder = "desc";
      } else if (sortOrder === "desc") {
        sortOrder = "asce";
      } else {
        sortOrder = "asce";
      }
    } else {
      sortOrder = "asce";
    }
    const fetchedPage = await (
      await fetch(
        "https://" +
          localConfig.SERVICE.URL +
          ":" +
          localConfig.SERVICE.PORT +
          `/api/sorted-filtered-presenter-events/${currentPresenterId}/0/${pageSize}/${fieldName}/${sortOrder}/${fromDate}/${toDate}/${upcomingEventsCheck}?${eveTypesQuery}&${eveStatusQuery}`,
        {
          credentials: "include",
        }
      )
    ).json();
    this.setState({
      pagedEvents: fetchedPage,
      currentPage: 0,
      currentPaginationHop: 1,
      sortedField: fieldName,
      sortOrder,
    });
    this.createPageArray();
  }

  async applyFilters() {
    console.log("applyFilters()");
    // const {xyz,
    // } = this.state;
    // let eveTypesQuery = this.eventTypesQueryURL(eventTypesFiltered);
    // let eveStatusQuery = this.eventStatusesQueryURL(statusFiltered);
  }

  async resetFilters() {
    console.log("resetFilters()");
    this.setState({
      currentPresenterId: -1,
      currentPresenter: null,
    });
  }

  async setDateRange(newRange) {
    if (newRange.length === 2) {
      let formattedFromDate = null;
      let formattedToDate = null;
      let from = newRange[0];
      let to = newRange[1];
      //from date formatting
      let month =
        parseInt(from.getMonth() + 1) > 9
          ? from.getMonth() + 1
          : "0" + (from.getMonth() + 1);
      let date =
        parseInt(from.getDate()) > 9 ? from.getDate() : "0" + from.getDate();
      formattedFromDate =
        from.getFullYear() + "-" + month + "-" + date + " 00:00:00";
      // to date formatting
      let tMonth =
        parseInt(to.getMonth() + 1) > 9
          ? to.getMonth() + 1
          : "0" + (to.getMonth() + 1);
      let tDate =
        parseInt(to.getDate()) > 9 ? to.getDate() : "0" + to.getDate();
      formattedToDate =
        to.getFullYear() + "-" + tMonth + "-" + tDate + " 23:59:00";

      this.setState({
        dateRange: newRange,
        fromDate: formattedFromDate,
        toDate: formattedToDate,
      });
    } else {
      this.setState({ dateRange: newRange, fromDate: null, toDate: null });
    }
  }

  filterEventTypes = (eveType) => (e) => {
    console.log("Event type: " + eveType);
    let { eventTypesFiltered } = this.state;
    if (e.target.checked === true) {
      console.log("Pushed event...");
      eventTypesFiltered.push(eveType);
      console.log(eventTypesFiltered);
    } else {
      console.log("filtered event");
      eventTypesFiltered = eventTypesFiltered.filter((x) => x !== eveType);
      console.log(eventTypesFiltered);
    }
    this.setState({ eventTypesFiltered });
  };

  handleChange = (panel) => (event, isExpanded) => {
    // console.log('handleChange() called on:' + panel);
    this.setState({
      expanded: isExpanded ? panel : false,
    });
  };

  render() {
    const { isLoading, dateRange, activePresenters, currentPresenter } =
      this.state;

    //Toast for selecting the presenter to fetch report.
    let presentersListSpace = null;
    if (activePresenters !== null) {
      presentersListSpace = activePresenters.map((presenter) => {
        return (
          <tr key={presenter.presenterId} id={presenter.presenterId}>
            <td style={{ whiteSpace: "nowrap" }}>
              <button
                onClick={() => {
                  this.getPresenterDefaultEventsView(presenter.presenterId);
                }}
              >
                {presenter.name} {presenter.lastName}
              </button>
            </td>
          </tr>
        );
      });
    } else {
      presentersListSpace = (
        <div className="mono-font">
          Error occurred in retrieving Presenters.
        </div>
      );
    }
    if (isLoading) {
      return (
        <div>
          <img className="loading" src="/loading.gif" alt="Loading..." />
        </div>
      );
    }
    const dateRangePicker = (
      <DateRangePicker
        placeholder={"Select date range..."}
        value={dateRange}
        onChange={this.setDateRange}
      />
    );

    return (
      <div>
        <AppNavbar />
        <Container>
          <h4 className="headLineSpace">Manager dashboard</h4>
          <div className="headLineSpace" style={{ maxWidth: "33rem" }}>

            <div className="row">
              <div className="col">
                  {dateRangePicker}
                  <Button 
                  style={{marginLeft:".5rem"}}
                  className="btn btn-primary"
                  onClick={() => this.applyFilters()}>Filter</Button>
              </div>
              <div className="col">
                  <Accordion
                  expanded={this.state.expanded === "panel1a"}
                  onChange={this.handleChange("panel1a")}
                  >
                  <AccordionSummary
                      expandIcon={<AssessmentIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                  >
                      <Typography>Select MOC</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                      <div>{presentersListSpace}</div>
                  </AccordionDetails>
                  </Accordion>
                </div>
                <div className="col" style={{ textAlign:"right" }}>
                  <Button 
                  style={{marginLeft:".5rem"}}
                  className="btn btn-primary"
                  onClick={() => this.resetFilters()}>Reset</Button>
              </div>
            </div>

          </div>
          <div>
            {currentPresenter && (
              <h3 className="paraSpace">
                MOC: {currentPresenter.name} {currentPresenter.lastName}
              </h3>
            )}
            <h4 className="paraSpace"># of events by type</h4>{/*  &amp; customers served */}
          </div>
          <div className="paraSpace">
            {/* <em style={{marginBottom:"1rem", display:"inline-block"}}>[CHART AREA]</em> */}
            <Chart presenterId={this.state.currentPresenterId} />
            </div>
            <div style={{ marginBottom: "5rem" }}>
            <CountyList presenterId={this.state.currentPresenterId} />
          </div>
        </Container>
      </div>
    );
  }
}
export default withCookies(ManagerDashboard);
